import Immutable from 'immutable';
import cookie from 'react-cookies'

export const State = Immutable.fromJS({
    token: typeof cookie.load('token') === 'undefined' ? null : cookie.load('token'),
});